import React from 'react';
import * as Yup from 'yup';
import { FormHandles } from '@unform/core';
import uuid from '../../../../core/components/UniqueHash';
import { useModal } from '../../../../../../hooks/Modal';
import FormComponent, { sanitizeDataObject } from '../../../../core/components/FormComponentUnique';
import { createSchemaByForm, IYup } from '../../../../../../utils/SchemaCreator';
import getValidationErrors from '../../../../../../utils/getValidationErrors';
import api from '../../../../../../services/api';
import { useToast } from '../../../../../../hooks/Toast';
import { useSearch } from '../../../../../../hooks/Search';
import { AxiosInstance } from 'axios';
import { FaDownload, FaPlus, FaUpload } from 'react-icons/fa';
import { useParams } from 'react-router-dom';
import { convertToXLSX } from 'src/utils/download';
import { dateFullWithHour } from 'src/utils/date';

interface ICreateModule {
  projectHash: string;
}

interface IParams {
  projectHash: string;
  eventHash: string;
}

export default function CreateModule({
  projectHash
}: ICreateModule): JSX.Element {
  const { reloadSearchAll } = useSearch();
  const { addModal, removeModal } = useModal();
  const { addToast } = useToast();



  const handleCreate = async () => {

    const subscriptions = await api.get('/course-products-subscriptions', {
      params: {
        where: { project_id: projectHash },
        limitItems: 10000
      }
    })

    const courses = await api.get('/course-products', {
      params: {
        where: { project_id: projectHash },
        limitItems: 10000
      }
    })



    const studentsIDs: Record<string, any> = [];

    subscriptions?.data?.rows?.map(i => {

      const index = studentsIDs?.findIndex(a => a?._id?.toString() === i?.client_id);

      if (index < 0) {
        studentsIDs.push({ _id: i?.client_id })
      }

    })


    if (studentsIDs?.length < 1) {
      addToast({ title: 'Nenhum usuário identificado', type: 'error' });
      return;
    }

    const students = await api.get('/students', {
      params: {
        where: { "$or": studentsIDs },
        limitItems: 10000
      }
    })

    const subscribers: Array<Array<string>> = [



    ];
    subscriptions?.data?.rows?.map(s => {

      const student = students?.data?.rows?.find(st => st?._id?.toString() === s?.client_id);

      const course = courses?.data?.rows?.find(c => c?._id?.toString() === s?.course_product_id_response?._id)

      subscribers.push([
        s?.course_product_id_response?.title,
        dateFullWithHour(course?.date),
        student?.name,
        student?.email,
        student?.phone,
        student?.position,
        student?.company,
        student?.state,
        student?.country



      ])


    })

    subscribers.sort((a, b) => `${a?.[0]}-${a?.[2]}` < `${b?.[0]}-${b?.[2]}` ? -1 : `${a?.[0]}-${a?.[2]}` > `${b?.[0]}-${b?.[2]}` ? 1 : 0)


    convertToXLSX(subscribers)

  };

  const moduleCreate = (): JSX.Element => (
    <button className="searchButton" type="button" onClick={handleCreate}>
      <FaDownload />
    </button>
  );

  return moduleCreate();
}
